
import { defineComponent, ref, reactive, watch, computed, PropType } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ethers } from "ethers";

import { ethereumConfig } from "@/config/project";

import Languages from "@/components/Languages.vue";
import Message from "@/components/Message.vue";

import { NFT, NFTData } from "./types";

import { useNFTs } from "./HomeUtils";

export default defineComponent({
  components: {
    Message,
    Languages,
  },
  props: {
    contract: {
      type: ethers.Contract,
      required: true,
    },
    provider: {
      type: [ethers.providers.Web3Provider, ethers.providers.AlchemyProvider],
      required: true,
    },
    accounts: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
  },
  setup(props) {
    const router = useRoute();
    const store = useStore();

    const { nfts, updateNFT, updateNftData, updateOwnerData } = useNFTs(
      props.contract
    );

    const { contractAddress, openseaUrl } = ethereumConfig;
    const nextToken = ref(0);
    const nounId = computed(() => {
      return router.params.nounId;
    });
    const nextNounId = computed(() => {
      const id = Number(nounId.value) + 1;
      if (id < nextToken.value) {
        return String(id);
      }
      return null;
    });
    const prevNounId = computed(() => {
      const id = Number(nounId.value) - 1;
      if (id > -1) {
        return String(id);
      }
      return null;
    });

    const bgColor = computed(() => {
      const nft = nfts.value[String(nounId.value)];
      if (nft) {
        return nft.bgColor;
      }
      return "bg-nouns-gray";
    });
    watch(bgColor, () => {
      store.commit("setBgColor", bgColor.value);
    });
    watch(nounId, () => {
      updateNftData(String(nounId.value));
      updateOwnerData(String(nounId.value));
    });
    const initEvent = () => {
      props.contract.functions.getCurrentToken().then((res) => {
        nextToken.value = res[0].toString();
      });
      updateNftData(String(nounId.value));
      updateOwnerData(String(nounId.value));
    };
    initEvent();
    return {
      contractAddress,
      openseaUrl,

      nextNounId,
      prevNounId,

      nfts,
      nounId,
      bgColor,
    };
  },
});
